import { client } from './api';

class MessageService {
  getAllConversations = async () => {
    const response = await client.get('message');
    return response;
  };

  getAllMessages = async conversationId => {
    const response = await client.get(`message/${conversationId}`);
    return response;
  };

  getDetailLastMessage = async conversationId => {
    const response = await client.get(`message/${conversationId}?ItemsPerPage=1&PageNumber=1`);
    return response;
  };

  sendMessage = async message => {
    const response = await client.post('message', message);
    return response;
  };

  setLastReadMessage = async (messageId, conversationId) => {
    const response = await client.post('message/MarkLastReadMessage', { messageId, conversationId });
    return response;
  };

  getUnreadConversationsCount = async () => {
    const response = await client.get('message/unreadconversationscount');
    return response;
  };

  getUnreadMessageCount = async conversationId => {
    const response = await client.get(`message/unreadmessagescount/${conversationId}`);
    return response;
  };
}

export default MessageService;
